import React, { useEffect, useState  } from 'react';
import Dialog from "../Dialog/Dialog";
import Autocomplete from "../Autocomplete/Autocomplete";

export default function FiltersDialog({ open, onClose, filters, setFilters, attributes, conditions, defaultFilters }) {
  
  // Temporary state for new filter inputs
  const [attribute, setAttribute] = useState('');
  const [condition, setCondition] = useState('');
  const [value, setValue] = useState('');

  // Close on Escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  useEffect(() => {
  if (!open) {
    setAttribute("");
    setCondition("");
    setValue("");
  }
  }, [open]);

  const addFilter = () => {
    if (!attribute || !condition || !value) return;
    const attr = attributes.find(a => a.value === attribute);
    const newFilter = { attribute, condition, value, type: attr?.type || "str", };
    setFilters([...filters, newFilter]);
    setAttribute('');
    setCondition('');
    setValue('');
  };

  // Compute possible conditions based on selected attribute
  const possibleConditions = () => {
    if (!attribute) return conditions;
    const attr = attributes.find(a => a.value === attribute);
    if (!attr) return conditions;
    //filter conditions by type (customize as needed)
    if (attr.type === 'str') return conditions.filter(c => ['==', '!=', 'in', 'not in', 'start', 'finish'].includes(c.value));
    else if (attr.type === 'number' || attr.type === 'int' ||attr.type === 'float') return conditions.filter(c => ['==', '!=', '>', '<', '>=', '<='].includes(c.value));
    else if (attr.type === 'date') return conditions.filter(c => ['==', '!=', '>', '<', '>=', '<='].includes(c.value));
    else if (attr.type === 'proposition') return conditions.filter(c => ['=='].includes(c.value));
    return conditions;
  };

  const handleRemove = (index) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  return (
      <Dialog open={open} onClose={onClose}>
            
        <h2>Filter Users</h2>

        {/* Filter Inputs */}
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
          
            <Autocomplete
              options={attributes}
              value={attribute}
              placeholder="Search attribute..."
              onChange={(val) => {
                setAttribute(val);
                setCondition("");
                setValue("");
              }}
            />

         {attribute && (
          <Autocomplete
            mode="select"            
            value={condition}              // current selected value
            onChange={setCondition}        // update function
            options={possibleConditions().map(c => ({
              label: c.label,              // what shows in the dropdown
              value: c.value               // value stored (can be c.id if you prefer)
            }))}
            placeholder="Select condition" // placeholder
          />
        )}


          {attribute && condition && (
          <>
            {(() => {
              const attr = attributes.find(a => a.value === attribute);
              if (!attr) return null;

              switch (attr.type) {
                case 'date':
                  return (
                    <input
                      type="date"//  datetime-local
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      placeholder="Select date"
                      //min="2026-01-01T00:00" max="2026-12-31T23:59"
                    />
                  );
                
                case 'proposition': // or "proposition" / "proposition_algo"
                  return (
                    <Autocomplete
                      mode="select" 
                      value={value}
                      onChange={setValue}
                      placeholder="Select value..."
                      options={(attr.select || []).map((opt) => ({ label: opt, value: opt }))}
                    />
                  );

                case 'proposition0': // or "proposition" / "proposition_algo"
                  return (
                    <Autocomplete
                      options={attr.select || []}
                      value={value}
                      placeholder="Select value..."
                      onChange={(val) => setValue(val)}
                    />
                  );

                case 'number':
                  return (
                    <input
                      type="number"
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      placeholder="Enter number"
                    />
                  );

                default: // str or any other type
                  return (
                    <input
                      type="text"
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      placeholder="Enter value"
                    />
                  );
              }
            })()}
          </>
        )}


          <button className="label-btn"
          onClick={addFilter} disabled={!attribute || !condition || !value}>Add</button>
        </div>

        {/* ACTIVE FILTER CHIPS */}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
          {filters.map((f, i) => {

            let display = "";

            switch (f.condition) {
              case "start":
                display = `${f.attribute} starts with ${f.value}`;
                break;
              case "finish":
                display = `${f.attribute} finishes with ${f.value}`;
                break;
              case "in":
                display = `${f.value} in ${f.attribute}`;
                break;
              case "not in":
                display = `${f.value} not in ${f.attribute}`;
                break;
              default:
                display = `${f.attribute} ${f.condition} ${f.value}`;
            }

            return (
              <span key={i} className="chipStyle">
                {display}
                {!defaultFilters.some(df => 
                  df.attribute === f.attribute &&
                  df.condition === f.condition &&
                  df.value === f.value
                ) && (
                  <button className="label-btn chip" onClick={() => handleRemove(i)} >
                    ×
                  </button>
                )}
              </span>
            );
          })}
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button className="label-btn" style={{ "--label-btn-color": "#43A047" }} onClick={() => { setFilters([defaultFilters[0]]); }}>Reset</button>
          <button className="label-btn" style={{ "--label-btn-color": "#43A047" }} onClick={onClose}>Close</button>
        </div>
      </Dialog>
  );
}



const chipStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  background: '#e0e0e0',
  borderRadius: 16,
};
